// The page background, --surface in base.css, as hex for the theme-color metas, which can't read CSS variables.
// public/manifest.webmanifest repeats the light one, so keep all three in sync
export const SURFACE = { light: "#fcfaf7", dark: "#101317" }

// The light theme's other colors in base.css, as hex for what's drawn off the page: the story image and link previews
export const LIGHT = { text: "#1a1d23", muted: "#5c6069", border: "#dcd9d3", accent: "#1a469d" }
